// extracted by mini-css-extract-plugin
export default {"headline":"headline-module___headline___c8f96199","item":"headline-module___item___b199e185","headline__icon":"headline-module___headline__icon___f7892ae4"};